import cx from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'

import { flipAnimation } from '@lib/animate'

interface GalleryCarouselCounterProps {
  currentSlide: number
  slideCount: number
  counterText: string
  cornerControls?: boolean
}

const GalleryCarouselCounter = ({
  currentSlide,
  slideCount,
  counterText,
  cornerControls,
}: GalleryCarouselCounterProps) => {
  return (
    <div
      className={cx('relative grid gap-px rounded-full', {
        'grid-cols-2 h-8 bg-pageBG text-pageText': !cornerControls,
        'grid-cols-3 h-auto bg-transparent text-pageText select-none':
          cornerControls,
      })}
    >
      {!cornerControls && (
        <div className="absolute left-1/2 transform -translate-x-1/2 inset-y-3 w-px bg-pageText opacity-30" />
      )}
      <div
        className={cx('relative flex flex-col p-2 pl-3', {
          'text-xs font-semibold overflow-hidden': !cornerControls,
          'px-0 text-base font-normal text-center overflow-visible':
            cornerControls,
        })}
      >
        <div className="relative overflow-hidden">
          <AnimatePresence initial={false}>
            <motion.span
              key={currentSlide + 1}
              initial="hide"
              animate="show"
              exit="hide"
              variants={flipAnimation}
              className="block will-change-transform absolute inset-x-0 top-0 last:static last:inset-x-auto last:top-auto"
            >
              {currentSlide + 1}
            </motion.span>
          </AnimatePresence>
        </div>
      </div>

      {cornerControls && (
        <div className="relative flex flex-col p-2 px-0 text-base font-normal text-center overflow-visible">
          <span>{counterText}</span>
        </div>
      )}

      <div
        className={cx('relative flex flex-col p-2 pr-3', {
          'text-xs font-semibold overflow-hidden': !cornerControls,
          'px-0 text-base font-normal text-center overflow-visible':
            cornerControls,
        })}
      >
        <span>{slideCount}</span>
      </div>
    </div>
  )
}

export default GalleryCarouselCounter
